import Routes from './routes'
import ManagementPortal from './store'
import Configuration from './modules/configuration/store'

import moment from 'moment-timezone'

// set global moment timezone to utc
moment.tz.setDefault('utc')

const Reducers = reducerObj => {
  reducerObj.management = ManagementPortal
  reducerObj.configuration = Configuration
}

export default Reducers

export { Routes, Reducers }
